import { SLEEP_TIME, TICK, TICK_DURATION, TRANSITION_DURATION } from "../constants/constants";
import { Values } from "./Values";

export interface TimeInterface {
    hours: number,
    minutes: number,
}

export interface TimeConstraint {
    before: TimeInterface,
    after: TimeInterface
}

/**
* Adds a '0' to string if number is smaller than 10.
* @param value String of seconds or minutes to display.
* @returns Corrected string of seconds or minutes to display.
*/
export function adjustDisplay(value: number) {
    if (value < 10) {
        return "0" + value;
    }
    return value;
}

/**
 * Converts seconds attribute to a displayable string.
 * @returns String of the remaining time.
 */
export function displayTime(time: TimeInterface) {
    return adjustDisplay(time.hours) + ":" + adjustDisplay(time.minutes);
}

/**
 * Converts string into the interface TimeInterface.
 * @param display String of the time.
 * @returns Time as an interface.
 */
export function stringToTimeInterface(display: string): TimeInterface {
    const params = display.split(":");
    return {
        hours: +params[0],
        minutes: +params[1]
    };
}

export function addMinutes(time: TimeInterface, m: number) {
    const newTime: TimeInterface = {
        hours: time.hours,
        minutes: time.minutes + m
    }

    const addedHours = Math.floor(newTime.minutes / 60.0);
    newTime.minutes = newTime.minutes % 60;
    newTime.hours += addedHours;
    // newTime.hours = newTime.hours % 24;

    return newTime;
}

/**
 * Function that compares two times.
 * @param timeA 
 * @param timeB 
 * @returns True if time A is before time B.
 */
export function isBefore(timeA: TimeInterface, timeB: TimeInterface) {
    return (
        timeA.hours < timeB.hours ||
        (timeA.hours == timeB.hours && timeA.minutes < timeB.minutes)
    );
}


export function canAdvanceTime(time: TimeInterface) {
    return isBefore(time, SLEEP_TIME);
}


export function getMinutesInBetween(timeA: TimeInterface, timeB: TimeInterface) {
    return Math.abs(timeA.hours * 60 + timeA.minutes - (timeB.hours * 60 + timeB.minutes));
}


export function updateTime(currentTime: TimeInterface, targetTime: TimeInterface, setTime: React.Dispatch<React.SetStateAction<TimeInterface>>, onStepFn: (step: number) => void, setValues: React.Dispatch<React.SetStateAction<Values>>, newValues: Values[]) {
    if (isBefore(currentTime, SLEEP_TIME)) {
        const N_MINUTES = getMinutesInBetween(currentTime, targetTime);
        const N_STEPS = Math.floor(N_MINUTES / TICK)

        const initialTime = currentTime;

        for (let i = 0; i < N_STEPS; ++i) {
            const nTicks = Math.min(TICK, TICK_DURATION);
            for (let j = 1; j <= nTicks; ++j) {
                setTimeout(() => {
                    setTime(addMinutes(initialTime, Math.floor(i * TICK + j / nTicks * TICK)));
                }, i * TICK_DURATION + j / nTicks * TICK_DURATION);
            }

            onStepFn(i);
        }
    }
}


export function tickStep(currentTime: TimeInterface, setTime: React.Dispatch<React.SetStateAction<TimeInterface>>) {
    const initialTime = currentTime;
    if (isBefore(currentTime, SLEEP_TIME)) {
        const nTicks = Math.min(TICK, TICK_DURATION);
        for (let i = 1; i <= nTicks; ++i) {
            setTimeout(() => {
                setTime(addMinutes(initialTime, Math.floor(i / nTicks * TICK)))
            }, Math.floor(i / nTicks * TICK_DURATION))
        }
    }
}